"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = exports.DefaultMultiSelectChildren = exports.MenuContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const CurrentSelection_1 = require("./CurrentSelection");
const Option_1 = require("./Option");
const Menu_1 = require("../Menu");
const Paragraph_1 = require("../Paragraph");
const Menu_2 = require("./Menu");
exports.MenuContainer = styled_components_1.default.div `
  border: 1px solid ${props => props.theme.Color.Layout.Line};
  border-radius: ${style_1.default.Design.Rounding.Tertiary};
  background: ${props => props.theme.Color.Layout.Lightest};
`;
/**
 * Convert selections into a label.
 */
function selectionsToLabel(selections) {
    return R.pipe(R.map(R.prop('label')), R.join(', '))(selections);
}
function DefaultMultiSelectChildren({ selections, }) {
    // Generate a label for the selected options.
    const label = react_1.default.useMemo(() => {
        return selectionsToLabel(selections);
    }, [selections]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!R.isEmpty(selections) && ((0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { children: label })), R.isEmpty(selections) && ((0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { children: "No Selections" }))] }));
}
exports.DefaultMultiSelectChildren = DefaultMultiSelectChildren;
function MultiSelect({ Option = Option_1.DefaultOption, children = DefaultMultiSelectChildren, onChange, options, value, }) {
    // Determine the currently selected options.
    const selections = react_1.default.useMemo(() => {
        return R.filter((option) => {
            return value.has(option.value);
        }, options);
    }, [options, value]);
    // Fired when an option is clicked.
    const onClickOption = react_1.default.useCallback(({ option, close, }) => {
        const next = new Set(value);
        value.has(option.value)
            ? next.delete(option.value)
            : next.add(option.value);
        onChange(next);
    }, [onChange, value]);
    const props = react_1.default.useMemo(() => {
        return {
            selections,
        };
    }, [selections]);
    return ((0, jsx_runtime_1.jsx)(Menu_1.Menu.Flyout, Object.assign({ content: ({ close }) => ((0, jsx_runtime_1.jsx)(Menu_2.SelectMenu, { Option: Option, onClick: (option) => onClickOption({ option, close }), isSelected: (set, option) => set.has(option.value), options: options, value: value })) }, { children: ({ toggle }) => {
            return ((0, jsx_runtime_1.jsx)(CurrentSelection_1.CurrentSelection, Object.assign({ onClick: toggle }, { children: children(props) })));
        } })));
}
exports.MultiSelect = MultiSelect;
